import { ActionType, getType } from 'typesafe-actions';

import { apiActions } from '../api/api.actions';
import { MerchGuideState } from './merchGuide.types';

const INITIAL_STATE: MerchGuideState = null;

export function merchGuide(
  state: MerchGuideState = INITIAL_STATE,
  action: ActionType<typeof apiActions>
): MerchGuideState {
  switch (action.type) {
    case getType(apiActions.getMerchGuideLink.request): {
      return null;
    }
    case getType(apiActions.getMerchGuideLink.success): {
      return action.payload;
    }
    default:
      return state;
  }
}
